import bus from '@/eventbus'

export default {
	LOADING: {
		text: 'Loading data',
		type: 'primary',
		timeout: -1,
		isLoading: true
	},
	SAVING: {
		text: 'Sending data to server',
		type: 'primary',
		timeout: -1,
		isLoading: true
	},
	SUCCESS: action => {
		return {
			text: `Data ${action} successfully`,
			type: 'success'
		}
	},
	ERROR: error => {
		return {
			text: error,
			type: 'error',
			timeout: 6000
		}
	},
	INFO: text => {
		return {
			text,
			type: 'info'
		}
	},
	showLoading() {
		bus.$emit('show-message', this.LOADING)
	},
	showSaving() {
		bus.$emit('show-message', this.SAVING)
	},
	showError(error) {
		bus.$emit('show-message', this.ERROR(error))
	},
	showSuccess(action) {
		bus.$emit('show-message', this.SUCCESS(action))
	}
}